import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { HBox, VBox } from "@ui/box/Box";
import { Typo } from "@ui/text/Typo";
import { useState } from "react";

const EntryValue = ({ value }: { value: string }) => {
	useLocale();
	const [expanded, setExpanded] = useState(false);
	const maxLength = 200;
	const isLong = value.length > maxLength;
	const displayValue = !isLong || expanded ? value : value.slice(0, maxLength) + "...";

	return (
		<VBox sx={{ flex: 1, alignItems: "flex-end", overflow: "hidden" }}>
			<Typo
				variant="medium"
				sx={{
					maxWidth: "95%",
					whiteSpace: expanded ? "normal" : "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis",
					wordBreak: "break-word",
					cursor: isLong ? "pointer" : "default",
				}}
				// title={value}
				onClick={() => {
					if (isLong) setExpanded(!expanded);
				}}>
				{displayValue}
			</Typo>
			{isLong && (
				<Typo variant="caption" sx={{ cursor: "pointer", opacity: 0.7 }} onClick={() => setExpanded(!expanded)}>
					{expanded ? msg("showLess") : msg("showMore")}
				</Typo>
			)}
		</VBox>
	);
};

export const ObjectViewer = ({ data }: { data: any }) => {
	useLocale();
	return (
		<VBox sx={{ overflow: "auto", flex: 1, overflowX: "hidden" }}>
			{Object.entries(data).map(([key, val]) => (
				<HBox gap="10px" key={key} sx={{ padding: "5px 10px", borderBottom: "1px solid #0000001f", justifyContent: "space-between" }}>
					<Typo variant="medium" sx={{ minWidth: "150px", fontWeight: 600 }}>
						{key}:
					</Typo>
					<EntryValue value={String(val)} />
				</HBox>
			))}
		</VBox>
	);
};
